import { render, staticRenderFns } from "./language-experiment.vue?vue&type=template&id=59aac982&scoped=true&"
import script from "./language-experiment.vue?vue&type=script&lang=js&"
export * from "./language-experiment.vue?vue&type=script&lang=js&"
import style0 from "./language-experiment.vue?vue&type=style&index=0&id=59aac982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aac982",
  null
  
)

export default component.exports